import { Link } from 'react-router-dom';

interface ProductCardProps {
  id: string;
  name: string;
  price: string;
  image: string;
  description: string;
  categoryName: string;
}

export default function ProductCard({ name, price, image, description, categoryName }: ProductCardProps) {
  return (
    <div className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300" data-product-shop>
      <div className="relative aspect-square overflow-hidden bg-background-100">
        <img
          src={image}
          alt={name}
          title={`${name} - 爱液官网正品`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700 rounded-full">
          {categoryName}
        </span>
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
          {name}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
          {description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-lg font-bold text-primary-600">{price}</span>
          <Link
            to="/categories"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            了解详情
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}